import { supabaseClient } from 'supabase'
import { DeskAlreadyDecidedError } from './deskDecisionError'

/**
 * Restore a rejected or auto-rejected candidate to the desk (`desk_restore`,
 * D-12). Returns the tab it lands on (e.g. 'ready' or 'needs_a_look').
 *
 * Errors are thrown raw; a `null` result (not restorable any more, e.g.
 * approved meanwhile or already restored) throws DeskAlreadyDecidedError (D-11).
 */
export const restoreCandidate = async (id: number): Promise<string> => {
  const { data, error } = await supabaseClient.rpc('desk_restore', { p_id: id })

  if (error) {
    throw error
  }
  if (data === null || data === undefined) {
    throw new DeskAlreadyDecidedError('desk_restore')
  }
  return data
}
